import { IFinSobValidationError } from '../../../models/IFinSobValidationError'

export const getReplaceParams = (validationError?: IFinSobValidationError) => {
  const valuesSuffix = validationError?.isSob ? '%' : ''
  const diffSuffix = validationError?.isSob ? ' pts' : '%'
  const thresholdSuffix = validationError?.isSob ? ' pts' : '%'

  return [
    { key: '{category}', value: validationError?.category ?? '' },
    { key: '{diff}', value: `${validationError?.diff ?? ''}${diffSuffix}` },
    { key: '{threshold}', value: `${validationError?.threshold ?? ''}${thresholdSuffix}` },
    { key: '{currentValueName}', value: validationError?.currentValueName ?? '' },
    { key: '{currentValueType}', value: validationError?.currentValueType ?? '' },
    { key: '{currentValuePeriod}', value: validationError?.currentValuePeriod ?? '' },
    { key: '{currentValue}', value: `${validationError?.currentValue ?? ''}${valuesSuffix}` },
    { key: '{comparisonValueName}', value: validationError?.comparisonValueName ?? '' },
    { key: '{comparisonValueType}', value: validationError?.comparisonValueType ?? '' },
    { key: '{comparisonValuePeriod}', value: validationError?.comparisonValuePeriod ?? '' },
    { key: '{comparisonValue}', value: `${validationError?.comparisonValue ?? ''}${valuesSuffix}` },
  ]
}
